import { useMemo } from 'react';

import { statisticsService } from '../../../services/statistics.service';
import { createApiSlice } from '../utils/createApiSlice';

const getFarmsStatisticsSlice = createApiSlice({
  reducerPath: ['statistics', 'getFarmsStatistics'],
  apiFunction: statisticsService.getFarmsStatistics,
  apiArgumentsFn: () => []
});

const { actions, useApiSelectors } = getFarmsStatisticsSlice;

export const getFarmsStatisticsActions = actions;

export const useGetFarmsStatisticsSelectors = () => {
  const { inProgress, errorMessage, success, response } = useApiSelectors();

  return useMemo(
    () => ({
      inProgress,
      errorMessage,
      success,
      response
    }),
    [errorMessage, inProgress, response, success]
  );
};

export default getFarmsStatisticsSlice;
